import { defineComponent as _defineComponent } from 'vue'
import Wizard from '@/components/wizard/Wizard.vue';
import { AlertOperator, AlertSeverity } from '@/models/enums/AlertsEnums';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { computed, reactive, onMounted } from 'vue';
import {
  StandardAlertCreationData,
  StandardAlertEditionData,
  StandardAlertFormData,
} from '../model';
import { useI18n } from '@/composables/i18n';
import GeneralDataWizardStep from '@/components/alerts/standardAlerts/GeneralDataWizardStep.vue';
import { StandardAlert } from '@/models/standardAlert';
import KpiSelectionFormWizardStep from '@/components/alerts/KpiSelectionFormWizardStep.vue';
import SummaryWizardStep from '@/components/alerts/standardAlerts/SummaryWizardStep.vue';
import { standardAlertsService } from '@/services/standardAlerts.service';
import VariableSelectionFormWizardStep from '@/components/alerts/VariableSelectionFormWizardStep.vue';
import { isNil } from '@/utils/misc';
import SourceSelectionFormWizardStep from '@/components/alerts/SourceSelectionFormWizardStep.vue';
import EventCodesSelectionFormWizardStep from '@/components/alerts/EventCodesSelectionFormWizardStep.vue';
import { alertsService } from '@/services/alerts.service';
import {
  areEventCodesRequiredBy,
  areSourcesRequiredBy,
  isVariableRequiredBy,
} from '@/utils/alerts';


export default /*#__PURE__*/_defineComponent({
  __name: 'StandardAlertWizard',
  props: {
    standardAlert: { default: null }
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { standardAlert: StandardAlert | null };





const formData: StandardAlertFormData = reactive({
  name: null,
  description: null,
  severity: AlertSeverity.Low,
  kpi: null,
  operator: AlertOperator.None,
  threshold: null,
  dateGrouping: FilterTimeAxisSpanEnum.None,
  variable: null,
  eventSources: [],
  eventCodes: [],
});

onMounted(() => {
  if (isEditing.value) {
    formData.name = props!.standardAlert!.name;
    formData.description = props!.standardAlert!.description;
    formData.severity = props!.standardAlert!.severity;
    formData.kpi = alertsService!.store!.getCareAlertKpiByMetric(
      props.standardAlert!.metric,
    );
    formData.operator = props!.standardAlert!.operator;
    formData.threshold = props!.standardAlert!.threshold;
    formData.dateGrouping = props!.standardAlert!.dateGrouping;
    formData.variable = props!.standardAlert!.variable;
    formData.eventSources = props!.standardAlert!.eventSources;
    formData.eventCodes = props!.standardAlert!.eventCodes;
  }
});

function onStepInput(value: StandardAlertFormData) {
  Object.assign(formData, value);
}

async function onSubmit() {
  const alertDefinition: StandardAlertCreationData = {
    name: formData.name!,
    description: formData.description,
    severity: formData.severity!,
    metric: formData.kpi!.kpi,
    operator: formData.operator,
    threshold: +formData.threshold!,
    dateGrouping: formData.dateGrouping,
    variable: formData.variable,
    eventSources: formData.eventSources,
    eventCodes: formData.eventCodes,
  };

  if (isEditing.value) {
    const alertEditionData: StandardAlertEditionData = {
      id: props.standardAlert!.id!,
      ...alertDefinition,
    };
    await standardAlertsService.update(alertEditionData);
  } else {
    await standardAlertsService.create(alertDefinition);
  }

  emit('save');
  emit('close');
}

function sanitizeFormData() {
  if (!isVariableRequiredByKpi.value) {
    formData.variable = null;
  }
  if (!areEventCodesRequiredByKpi.value) {
    formData.eventCodes = [];
  }
  if (!areSourcesRequiredByKpi.value) {
    formData.eventSources = [];
  }

  formData.name = formData.name?.trim() ?? null;
  formData.description = formData.description?.trim() ?? null;
}

const isVariableRequiredByKpi = computed<boolean>(() =>
  isVariableRequiredBy(formData.kpi),
);

const areSourcesRequiredByKpi = computed<boolean>(() =>
  areSourcesRequiredBy(formData.kpi),
);

const areEventCodesRequiredByKpi = computed<boolean>(() =>
  areEventCodesRequiredBy(formData.kpi),
);

const title = computed<string>(() =>
  isEditing.value
    ? t('e_service_center.standard_alert_wizard.edit_title').toString()
    : t('e_service_center.standard_alert_wizard.create_title').toString()
);

const isEditing = computed<boolean>(() =>
  !isNil(props.standardAlert),
);

const { t } = useI18n();

return { __sfc: true,props, emit, formData, onStepInput, onSubmit, sanitizeFormData, isVariableRequiredByKpi, areSourcesRequiredByKpi, areEventCodesRequiredByKpi, title, isEditing, t, Wizard, GeneralDataWizardStep, KpiSelectionFormWizardStep, SummaryWizardStep, VariableSelectionFormWizardStep, SourceSelectionFormWizardStep, EventCodesSelectionFormWizardStep }
}

})